import { FormGroup } from '@angular/forms';
import { IFormSelectOption } from '../shared/models/forms';
import {
  IFigureAnagrafiche,
  IInvestmentLine,
  IPagatore,
  IPolicyAsset,
} from '../shared/models/policy.model';
import { IDocumentUpdate } from './components/beneficiary-change-isv/beneficiary-change-isv.constants';
import { EmployerTableRow } from './components/spostamento-iscritto/spostamento-iscritto.constants';
import { EDashboardStatus } from 'src/app/pages/dashboard/dashboard.constants';

export const OP_WITH_QUESTIONNAIRE_UNI20: string[] = [
  '_RISTO',
  '_RISPA',
  '_VAGG',
  '_VCONT',
  '10',
];

export const OP_WITH_QUESTIONNAIRE_UNI30: string[] = [];

export const OP_WITH_INSURED_CHECK: string[] = [
  '_RISTO',
  'INT_003',
  '_VRECP',
  '69',
  '_RISPA',
  '10',
  '_SWITR',
  '_SWITC',
  '_VAGG',
  '_VCONT',
];

export const CAN_CHANGE_NDG_ISV: string[] = [
  '_RISTO',
  '_RISPA',
  '_SWITC',
  '_SWITR',
  'VU',
  '_VAGG',
];

export const ISV_OPERATIONS_WITH_IBAN: string[] = [
  '_RISTO',
  '_RISPA',
  '_VAGG',
  '10',
  '_VCBMU',
];

export const ISV_CANCEL_OPERATIONS: string[] = ['_ANAPP'];

export const ISV_MULTI_STEP_OPERATIONS: string[] = ['_SWITR'];

export const CONNOT_CALL_FORM_FIELDS: string[] = ['_VCBMU'];

export const NEED_PERCENTAGE_BOX_FIELDS: string[] = [
  'subscriberAllocation',
  'companyAllocation',
  'TFRAllocation',
  'pInvestment',
];

export const CAN_ALWAYS_OPERATE_ISV: string[] = ['_VBENE', 'INT_001'];
export const INSURED_NOT_ALIVE_MSG =
  "L'assicurato non è più in vita. Non è possibile proseguire con l'operazione.";
export const HOLDER_NOT_REDEEMING_MSG =
  "Il contraente non richiede la liquidazione a suo favore. Per procedere con l'operazione è necessario mandare la richiesta scritta alla compagnia";
export const CHECK_TUTOR_MSG =
  'Il contraente è un soggetto tutelato/assistito?';
export const CHECK_REDEEM_INTENT_MSG =
  'Il contraente non coincide con il beneficiario. Il contraente richiede la liquidazione a suo favore?';
export const DIFFERENT_OP_DRAFT_MSG =
  'È presente una diversa operazione in bozza per la polizza corrente.';
export const DIFFERENT_OP_COMPLETED_MSG =
  "È presente un'operazione completata in data odierna per la polizza corrente.";
export const SAME_OP_COMPLETED_MSG =
  "È già presente un'operazione dello stesso tipo completata in data odierna per la polizza corrente.";
export const OP_COMPLETED_MSG =
  "La tua operazione è stata inviata correttamente. Puoi tornare alla polizza per continuare con l'operatività.";

export const ISV_OPERATION_NOT_PERMITTED_MSG = [
  {
    code: '01',
    message:
      'non ammessa. È presente una diversa operazione in corso per la polizza corrente.',
  },
  {
    code: '02',
    message:
      'non ammessa. È necessario sanare il legame contraente/beneficiario che risulta essere mancante.',
  },
  {
    code: '03',
    message:
      'non ammessa. La polizza risulta essere in gestione presso altra filiale.',
  },
  {
    code: '04',
    message:
      'non ammessa per la linea di investimento in vigore sulla polizza.',
  },
  {
    code: '05',
    message:
      'non ammessa. La pratica di scadenza non è ancora stata elaborata.',
  },
  {
    code: '06',
    message:
      'non ammessa. Attività non prevista/commercializzata per questo prodotto.',
  },
];

export const TYPES_WITH_TAE_REQUIRED = ['Non occupato', 'Pensionato']

export interface IPersonIntestaFormGroups {
  registryForm: FormGroup;
  residenceForm: FormGroup;
  identificationDocumentForm: FormGroup;
  properVerificationForm?: FormGroup;
}

export interface IGenericListIsv {
  code: string | number;
  description: string;
}

export interface INationPrevidential {
  c_nazione: string | number;
  descrizione: string;
}

export interface IProvincePrevidential {
  c_provincia: string | number;
  descrizione: string;
}

export interface FractionsDomainPrevidenziali {
  c_frazionamento: string;
  descrizione: string;
}

export interface FractionsDomainPrevidenziali {
  c_frazionamento: string;
  descrizione: string;
}

export interface IStoricoComunePrevidential {
  cComune: string;
  cProvincia: string;
  descrizione: string;
}

export interface IAnagraficaRelazioneContraente {
  c_relazione: string;
  descrizione: string;
}

export const gianos_operation_data_form_template = {
  agencyCode: { value: null, disabled: true },
  policyNumber: { value: null, disabled: true },
  productCode: { value: null, disabled: true },
  productCategory: { value: null, disabled: false },
  reportScope: { value: null, disabled: false },
  additionalPaymentType: { value: null, disabled: true },
  redeemType: { value: null, disabled: true },
  liquidationType: { value: null, disabled: true },
  withdrawalType: { value: null, disabled: true },
  operationAmount: { value: null, disabled: true },
  paymentType: { value: '08', disabled: true },
  fundOriginCountry: { value: null, disabled: false },
  fundOrigin: { value: null, disabled: false },
  fundOriginNote: { value: null, disabled: true },
  designedBeneficiary: { value: 'NO', disabled: false },
  contractorNotInsured: { value: null, disabled: false },
};

export interface IIntesaFormFieldsResponse {
  bankBranches?: IBankBranch[];
  documentTypes?: any[];
  documentReleaseAuthority?: any[];
  saeList?: any[];
  atecoList?: any[];
  countriesList?: any[];
  provincesList?: any[];
  holderBeneficiaryRelationshipList?: any[];
  insuredBeneficiaryRelationshipList?: any[];
  beneficiaryDeathTipologies?: any[];
  beneficiaryLifeTipologies?: any[];
  documentationList?: string;
  fundsOrigin?: string[];
  incomeLevels?: string[];
  executionMode?: string[];
  operationExecutionMode?: string[];
  paymentMethods?: any[];
  presenceInExternalList?: string[];
  productCategories?: string[];
  riscattoTypes?: string[];
  versamentoTypes?: string[];
  tipoBeneficiario?: any;
  dettaglioBeneficiari?: any;
}

export interface IBankBranch {
  CodiceABI: string;
  CodiceCAB: string;
  DenominazioneBanca: string;
  DenominazioneFiliale: string;
}

export interface IIntesaFormFieldsObj {
  documentTypeList?: IFormSelectOption[];
  agreementPurposeList?: IFormSelectOption[];
  customerBehaviourList?: IFormSelectOption[];
  documentReleaseAuthorityList?: IFormSelectOption[];
  saeList?: IFormSelectOption[];
  taeList?: IFormSelectOption[];
  atecoList?: IFormSelectOption[];
  activityTypes?: IFormSelectOption[];
  countriesList?: IFormSelectOption[];
  provincesList?: IFormSelectOption[];
  holderBeneficiaryRelationshipList?: IFormSelectOption[];
  insuredBeneficiaryRelationshipList?: IFormSelectOption[];
  beneficiaryDeathTipologies?: IFormSelectOption[];
  beneficiaryLifeTipologies?: IFormSelectOption[];
  documentationList?: IFormSelectOption[];
  fundsOriginList?: IFormSelectOption[];
  businessTypes?: IFormSelectOption[];
  incomeLevelsList?: IFormSelectOption[];
  executionModeList?: IFormSelectOption[];
  operationExecutionModeList?: IFormSelectOption[];
  paymentMethodsList?: IFormSelectOption[];
  presenceInExternalList?: IFormSelectOption[];
  productCategoriesList?: IFormSelectOption[];
  riscattoTypesList?: IFormSelectOption[];
  versamentoTypesList?: IFormSelectOption[];
  tableValues?: IFormSelectOption[];
  previdentialBeneficiariesTypes?: IFormSelectOption[];
  previdentialBeneficiariesList?: IFormSelectOption[];
  comuniList?: IFormSelectOption[];
  documentReleaseAuthorities?: IFormSelectOption[];
  documentTypesDomain?: IFormSelectOption[];
  professionsList?: IFormSelectOption[];
  incomeBracketsList?: IFormSelectOption[];
  frequenciesList?: IFormSelectOption[];
  beneficiariesClassification?: IFormSelectOption[];
  relazioneContraenteBeneficiario?: IFormSelectOption[];
  relazioneContraenteAssicurato?: IFormSelectOption[];
  relazioneContraenteEsecutore?: IFormSelectOption[];
  tipoDelega?: IFormSelectOption[];
  retirementDate?: string;
  debitDate?: string;
  effectDate?: string;
  activeFunds?: IPolicyAsset[];
  investmentFunds?: IPolicyAsset[];
  operationCost?: string;
  operationEffectDate?: string;
  lines?: IInvestmentLine[];
  rebalancedLine?: IInvestmentLine;
  iscritto?: string;
  payersList?: IPagatore[];
  payerDocumentTypesList?: IFormSelectOption[];
  payerDocumentReleaseAuthoritesList?: IFormSelectOption[];
  figureAnagrafiche?: IFigureAnagrafiche[];
  currentInstallmentAmount?: string;
  currentFrequency?: string;
  currentEmployersData?: EmployerTableRow[];
  currentBranchOffice?: string;
  chargeTypes?: IFormSelectOption[];
  previousDocuments?: IDocumentUpdate[];
  productCategory?: string;
  reportScope?: string;
  operationPurposeList?: any[];
  describeExtraData?: any
  redemptionTypes?: string[];
}

export interface IGianosPolicyHolder {
  // mandatory for PF
  nome?: string;
  cognome?: string;
  codiceFiscale?: string;
  cittadinanza1?: string;
  cittadinanza2?: string;
  comuneResidenza?: string;
  capResidenza?: string;
  dataNascita?: string;
  documentoIdentita?: string;
  dataRilascioDocumento?: string;
  fasciaRedditoFatturatoContraente?: string;
  indirizzoResidenza?: string;
  luogoNascita?: string;
  numeroDocumentoIdentita?: string;
  provinciaNascita?: string;
  provinciaResidenza?: string;
  rilasciatoDa?: string;
  sesso?: string;
  statoEsteroNascita?: string;
  statoEsteroResidenza?: string;
  tipologiaAttivita?: string;
  codiceTAE?: string;

  // mandatory for PG
  capSedeLegale?: string;
  classeBeneficiariSuCuiSiRivolgonoLeAttivita?: string; // TODO
  codiceATECO?: string;
  comuneSedeLegale?: string;
  dataCostituzione?: string; // TODO
  indirizzoSedeLegale?: string;
  partitaIVA?: string;
  provinciaSedeLegale?: string;
  ragioneSociale?: string;
  statoEsteroSedeLegale?: string;
  tipoSocietaImpresa?: string;

  // mandatory for PG and PF
  presenzaNelleListeEsterne?: boolean;
  comuneRecapito?: string;
  capRecapito?: string;
  indirizzoRecapito?: string;
  provinciaRecapito?: string;
  statoEsteroRecapito?: string;

  // optional for PF and PG
  codiceSAE?: string;
}

export interface IGianosPolicyInsured {
  nome: string;
  cognomeDenominazioneSociale: string;
  dataNascitaCostituzione: string;
  codiceFiscale: string;
  presenzaListeEsterne: string;
  luogoNascitaCostituzione: string;
}

export interface IGianosOperationInfo {
  numeroAgenzia?: string;
  numeroPropostaPolizza?: string;
  riscattoPrestito?: string;
  mezziPagamento?: string;
  paeseProvenienzaDestinazioneFondi?: string;
  origineFondi?: string;
  notaOrigineFondi?: string;
  importoOperazione?: string;
  liquidazione?: string;
  scopoRapporto?: string;
}

export interface IGianosDatiOperatore {
  dataSottoscrizioneRilevatore: string;
  comportamentoTenutoCliente?: string;
}

export interface IGianosEsecutoreConto {
  capDomicilio?: string;
  capResidenza?: string;
  capSedeLegale?: string;
  capSedeOperativa?: string;
  cittadinanza1?: string;
  cittadinanza2?: string;
  codiceFiscale?: string;
  cognome?: string;
  sesso?: string;
  comuneDomicilio?: string;
  comuneResidenza?: string;
  comuneSedeLegale?: string;
  comuneSedeOperativa?: string;
  dataNascita?: string;
  dataRilascioDocumento?: string;
  documentoIdentita?: string;
  domicilio?: string;
  indirizzoResidenza?: string;
  indirizzoSedeLegale?: string;
  luogoNascita?: string;
  nome?: string;
  numeroDocumentoIdentita?: string;
  paeseSedeLegaleCapogruppo?: string;
  presenzaNelleListeEsterne?: string;
  provinciaDomicilio?: string;
  provinciaNascita?: string;
  provinciaResidenza?: string;
  provinciaSedeLegale?: string;
  provinciaSedeOperativa?: string;
  relazioneContraenteEsecutore?: string;
  rilasciatoDa?: string;
  sedeOperativa?: string;
  statoEsteroDomicilio?: string;
  statoEsteroNascita?: string;
  statoEsteroResidenza?: string;
  statoEsteroSedeLegale?: string;
  statoEsteroSedeOperativa?: string;
  tipoDelega?: string;
}

export interface IGianosDesignazioneBeneficiari {
  designazioneBeneficiarioIndividuato: 'SI' | 'NO';
  nome?: string;
  codiceFiscale?: string;
  cognomeDenominazioneSociale?: string;
  dataNascitaCostituzione?: string;
  luogoNascitaCostituzione?: string;
  partitaIVA?: string;
  descrizione?: string;
  relazioneContraenteBeneficiario?: string;
  relazioneAssicuratoBeneficiario?: string;
}

export interface IGianosTitolareEffettivo {
  capDomicilio?: string;
  capResidenza?: string;
  cittadinanza1?: string;
  cittadinanza2?: string;
  codiceFiscale?: string;
  cognome?: string;
  comuneDomicilio?: string;
  comuneResidenza?: string;
  dataNascita?: string;
  dataRilascioDocumento?: string;
  documentoIdentita?: string;
  domicilio?: string;
  indirizzoResidenza?: string;
  luogoNascita?: string;
  note?: string;
  numeroDocumentoIdentita?: string;
  provinciaDomicilio?: string;
  provinciaNascita?: string;
  provinciaResidenza?: string;
  relazioneTitolareEffettivoContraente?: string;
  rilasciatoDa?: string;
  sesso?: string;
  statoEsteroDomicilio?: string;
  statoEsteroNascita?: string;
  statoEsteroResidenza?: string;
  ulterioriInformazioniTitolareEffettivo?: string;
}

export interface IGianosPaymentMode {
  code: string;
  iban: string;
  bic?: string;
  amount: string;
  address?: any;
}

export interface IGianosFunsList {
  fundCode: string;
  amount: string;
  stringOfQuotes?: string;
  quoteValue: string;
  currentValue: string;
}

export interface IGianosPrivacy {
  datiSensibili?: boolean; // privacy3 PF
  contrattuale?: boolean; // privacy1 PF
  commerciale?: boolean; // privacy2 PF

  commercialePGDati?: boolean; // privacy1 PG
}

export interface IGianosAdequateVerification {
  riskCode?: string;
  incomeLevel?: string;
  interestInPublicFunds?: boolean;
  isPoliticallyExposed?: string;
  professionCode?: string;
  taxOrVatCode?: string;
  filledPositions?: string[];
}

export interface IGianosHoldersRelationship {
  TipoRelazione: string;
  Descrizione: string;
  TipoContraente: string;
  TipoContraenteNew: string;
}

export const NOT_DRAFT_OPERATION_STATES = [
  EDashboardStatus.TO_UPLOAD,
  EDashboardStatus.COMPLETED,
];

export const COMPLETED_OPERATION_STATES = [
  EDashboardStatus.DOC_SENT,
  EDashboardStatus.COMPLETED,
];
